module.exports = __webpack_public_path__ + "img/one.c94d05ad.png";